// extracted by mini-css-extract-plugin
module.exports = {"DarkButton":"DarkThemeButton_DarkButton__12d80"};